import { Resource } from '@topconagriculture/permissions';
import { WidgetFooterType, WidgetHeaderType, WidgetSize, WidgetType } from '../widget.types';
import { widgetSizeEditModalName } from '../WidgetConfig';
export const inventoryLargeModalName = '@@widget/inventory/detail';
export const InventoryWidgetConfig = {
    type: WidgetType.INVENTORY,
    single: true,
    thumbnail: '/assets/images/dashboard/widget-catalog/inventory.jpg',
    title: 'widget:inventory:title',
    description: 'widget:inventory:description',
    permissions: [Resource.FEED_WIDGET_INVENTORY],
    header: () => ({
        type: WidgetHeaderType.GENERIC,
        actions: [
            {
                title: 'common:settings',
                modal: widgetSizeEditModalName,
            },
        ],
    }),
    footer: () => ({
        type: WidgetFooterType.EMPTY,
        href: '',
        text: '',
    }),
    baseConfig: {
        type: WidgetType.INVENTORY,
        w: 2,
        h: 2,
        x: 0,
        y: 0,
    },
    init: () => {
        return {
            type: WidgetType.INVENTORY,
            config: { size: WidgetSize.XS },
            w: 2,
            h: 2,
            x: 0,
            y: 0,
        };
    },
};
//# sourceMappingURL=InventoryWidgetConfig.js.map